import { EMPTY_OBJECT } from '../../../constants/common'
import { FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION } from '../../../constants/form'
import { SIZE } from '../../../constants/size'
import { useUkTimeZone } from '../../../hooks'
import { FormModal } from '../../Form'

import { FormFields } from './FormFields'
import { QA_NAME_EDIT_DEADLINE_MODAL } from './TaskEditDeadlineModal.constants'
import {
  getTaskEditDeadlineActionTypes,
  getTaskEditDeadlinePayload,
  getTaskEditDeadlineValidationSchema,
} from './TaskEditDeadlineModal.utils'

function TaskEditDeadlineModal({
  formFieldsProps: {
    actionTypes = getTaskEditDeadlineActionTypes(),
    ...formFieldsProps
  } = EMPTY_OBJECT,
  getPayload = getTaskEditDeadlinePayload,
  getValidationSchema = getTaskEditDeadlineValidationSchema,
  initialValues,
  onSubmit,
  ...restProps
}) {
  const { timezone } = useUkTimeZone()

  const validationSchema = getValidationSchema()

  function handleSubmit({ values }) {
    onSubmit({
      payload: getPayload(values, timezone),
      values,
    })
  }

  return (
    <FormModal
      {...restProps}
      Fields={FormFields}
      containerProps={{
        boxSize: SIZE.MEDIUM,
        qaName: QA_NAME_EDIT_DEADLINE_MODAL,
      }}
      formBodyProps={FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION}
      formFieldsProps={{ ...formFieldsProps, actionTypes }}
      formTitle='Task.EditDeadlineModalTitleKey'
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    />
  )
}

export default TaskEditDeadlineModal
